import { Chip } from "@mui/material";
import styled from "styled-components";

export const NotificationStatItem = styled(Chip).attrs({
  size: "small",
})`
  .MuiChip-label {
    padding-inline: 5px;
  }
`;
